import React from 'react';

export default function BotaoCabecalho(props) {
  return (
    <div
      className="DropdownItens"
      onClick={() => {
        props.clicado();
      }}
    >
      <img src={props.imagem} />
      <h4
        style={{
          fontFamily: 'montserrat',
          fontSize: '14px',
          color: '#2f2f2f',
          paddingLeft: 8,
          fontWeight: 600,
        }}
      >
        {props.texto}
      </h4>
    </div>
  );
}
